import {useRef, useState} from 'react';
import appConstants from '../../../../../../../../../constants';
import { KEYS } from '../../../../../../../../../l18n/constants';
import { useL18nContext } from '../../../../../../../ContextProvider/L18n';
import { usePartnerSearchContext } from '../../../../../../../ContextProvider/Partner/Search';
import { useScreenContext } from "../../../../../../../ContextProvider/Screen";
import CCButtonClear from '../../../../../../../../libs/CiscoCore/Button/Clear';
import computeClassName from '../../../../../../../../../utils/computeClassName';
import CCFormInput from '../../../../../../../../libs/CiscoCore/Form/Input';
import CCIconSearch16x16 from '../../../../../../../../libs/CiscoCore/Icon/Search/16x16';
import CCIconSearch20x20 from '../../../../../../../../libs/CiscoCore/Icon/Search/20x20';
import ProcessingIndicator from "../../../../../../../ProcessingIndicator";
import useClickOutside from '../../../../../../../../../hooks/ui/useClickOutside';
import IconClock from "../../../../../../../Icon/Clock";

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

function getComputedInputSize(useLargeDropdown) {
  return useLargeDropdown ? 'large':'medium';
}

function getComputedSearchIconComponent(useLargeIcon) {
  return useLargeIcon ? CCIconSearch20x20 : CCIconSearch16x16
}


function PartiallyHighlightedSuggestionTerm({suggestionTerm, suggestionTermLowercase, searchTerms}) {
  return <>{suggestionTerm}</>;

  //let suggestionTermToBeProcessed = suggestionTerm;
  //let suggestionTermToBeProcessedLowercase = suggestionTermLowercase;
  //let content = [];
//
  //searchTerms.forEach(
  //  (searchTerm) => {
  //    console.log('searched term: ',searchTerm);
  //    const elements = suggestionTermToBeProcessedLowercase.split(searchTerm);
  //    console.log('elements, elements length and type', elements, elements.length, typeof elements);
  //    elements.forEach(
  //      (contentElement) => {
  //        console.log('Content element: ',contentElement);
  //        if (contentElement === '') {
  //          content.push(
  //            {
  //              text: suggestionTermToBeProcessed.substring(suggestionTermToBeProcessedLowercase.indexOf(searchTerm),searchTerm.length),
  //              isHighlighted: true
  //            }
  //          );
  //          //const indexStart = suggestionTermToBeProcessedLowercase.indexOf(searchTerm);
  //          //const indexEnd = indexStart + searchTerm.length;
  //          //suggestionTermToBeProcessed =
  //          //  `${suggestionTermToBeProcessed.substring(0,indexStart)}${suggestionTermToBeProcessed.substring(indexEnd)}`;
  //          //console.log(suggestionTermToBeProcessed);
  //        }
  //        else {
  //          content.push(
  //            {
  //              text: suggestionTermToBeProcessed.substring(suggestionTermToBeProcessedLowercase.indexOf(contentElement)),
  //              isHighlighted: false
  //            }
  //          );
  //        }
  //      }
  //    );
  //  }
  //);
  //return (
  //  <>
  //    {
  //      content.map((contentElement, index) => {
  //        return contentElement.isHighlighted ?
  //          <span key={index} className="text-cc-muted-contrast">{contentElement.text}</span>:
  //          <Fragment key={index}>{contentElement.text}</Fragment>
  //      })
  //    }
  //  </>
  //  );
}

function HighlightedSuggestion({suggestion, searchTerms}) {
  let suggestionTerms = suggestion.replace(/[_\W]/g, ' ').split(' ');
  suggestionTerms = suggestionTerms.filter(suggestionTerm => !!suggestionTerm);
  return (
    <>
      {
        suggestionTerms.map(
          (suggestionTerm, index) => {
            const suggestionTermLowercase = suggestionTerm.toLowerCase();
            if (searchTerms.includes(suggestionTermLowercase)) {
              return (<span key={index} className="text-cc-muted-contrast mr-cc-1char">{suggestionTerm}</span>);
            }
            else {
              return (<span key={index} className="mr-cc-1char"><PartiallyHighlightedSuggestionTerm suggestionTerm={suggestionTerm} suggestionTermLowercase={suggestionTermLowercase} searchTerms={searchTerms} /></span>)
            }
          }
        )
      }
    </>
  );
}

function getComputedSelectSuggestionFn(suggestion, suggestionTypeKey, suggestionSubTypeKey, suggestionTypeSubTypeSelectFnMapping, closeSuggestionBoxFn) {
  return () => {
    closeSuggestionBoxFn();
    suggestionTypeSubTypeSelectFnMapping[`${suggestion[suggestionTypeKey]}-${suggestion[suggestionSubTypeKey]}`](suggestion);
  }
}

function getComputedSelectRecentSearchFn(
  recentSearch,
  recentSearchRestorationFn,
  selectCountryFilterValueFn,
  resetSelectedSuggestionFromSearchCriteriaFn,
  closeSuggestionBoxFn
) {
  return () => {
    closeSuggestionBoxFn();
    const searchCriteria = recentSearch?.searchCriteria;
    if (!!searchCriteria && !!searchCriteria.length) {
      //searchToBeRestored, selectCountryFilterValue, resetSelectedSuggestionFromSearchCriteria, errorNotificationFn
      recentSearchRestorationFn(recentSearch,selectCountryFilterValueFn, resetSelectedSuggestionFromSearchCriteriaFn);
    }
  }
}

export default function SearchByCombinedCriteriaForm({ className }) {

  const [isOpened, setIsOpened] = useState(false);

  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const { isScreenMDAndUp } = useScreenContext();
  const computedInputSize = getComputedInputSize(isScreenMDAndUp);
  const ComputedSearchIconComponent = getComputedSearchIconComponent(isScreenMDAndUp);

  const {
    searchTerms,
    updateSearchTerms,
    clearSearchTerms,
    isGetSuggestionsProcessingInProgress,
    getSuggestionsProcessingError,
    partnerIntegratorLevelSuggestions,
    partnerProviderLevelSuggestions,
    partnerDeveloperLevelSuggestions,
    partnerAdvisorLevelSuggestions,
    partnerIntegratorSpecializationSuggestions,
    partnerProviderCiscoPoweredServiceSuggestions,
    partnerNameSuggestions,
    //searchedTermsAsPartnerNameSuggestion,
    selectedCountry,
    selectCountryFilterValue,
    resetSelectedSuggestionFromSearchCriteria,

    suggestionTypeSubTypeSelectFnMapping,
    recentSearches,
    restoreSearch,
  } = usePartnerSearchContext();

  const componentRef = useRef();

  function open() {
    setIsOpened(true);
  }
  function close() {
    setIsOpened(false);
    if (!!searchTerms && !!searchTerms.length) { clearSearchTerms() }
  }

  useClickOutside(componentRef, close);

  let dynamicInputProps = {};
  if (!!searchTerms && !!searchTerms.length) {
    dynamicInputProps['rightSideComponent'] =
      isGetSuggestionsProcessingInProgress ? <ProcessingIndicator size="medium"/> : <CCButtonClear size={computedInputSize} clearFn={clearSearchTerms}/>

  }

  const isInputDisabled = !selectedCountry || (isGetSuggestionsProcessingInProgress === true);


  const suggestionGroups = [
    //searchedTermsAsPartnerNameSuggestion,
    partnerNameSuggestions,
    partnerIntegratorLevelSuggestions,
    partnerProviderLevelSuggestions,
    partnerDeveloperLevelSuggestions,
    partnerAdvisorLevelSuggestions,
    partnerIntegratorSpecializationSuggestions,
    partnerProviderCiscoPoweredServiceSuggestions,
  ].filter(suggestionGroup => !!suggestionGroup && !!suggestionGroup.groupSuggestions.length);

  const haveSuggestionsBeenFound = suggestionGroups.length > 0;

  let splitSearchTerms = searchTerms.replace(/[_\W]/g, ' ').split(' ');
  splitSearchTerms = splitSearchTerms.map(splitSearchTerm => splitSearchTerm.toLowerCase());

  return (
    <div className={computedClassName}>
      <div className="relative" ref={componentRef}>
        <CCFormInput className="z-20"
                     size={computedInputSize}
                     isDisabled={isInputDisabled}
                     hasError={!!getSuggestionsProcessingError}
                     value={searchTerms}
                     changeFn={updateSearchTerms}
                     focusFn={open}
                     placeholderText={!!getSuggestionsProcessingError?getSuggestionsProcessingError:getTranslationFor(KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE)}
                     leftSideComponent={<ComputedSearchIconComponent/>}
                     {...dynamicInputProps}/>
        {
          ((!!searchTerms && !!searchTerms.length)  || isOpened) &&

          <div className="max-h-80 z-10 overflow-y-auto absolute w-full top-cc-full-1 bg-cc-white text-cc-gray-100 border border-cc-accent rounded-lg shadow-cc-lg px-4 pb-1.5 text-cc-body-medium md:text-cc-body-large space-y-3">
            {
              haveSuggestionsBeenFound &&
              <>
                {
                  suggestionGroups.map(
                    (suggestionGroup, suggestionGroupIndex) => {
                      return (
                        <ul className="relative" key={suggestionGroupIndex}>
                          <li
                            className="-mx-4 px-4 pt-4 pb-1 uppercase sticky top-0 bg-cc-primary text-cc-muted-contrast">{suggestionGroup.groupName}</li>
                          {
                            suggestionGroup.groupSuggestions.map(
                              (suggestion, index) => {
                                const computedSelectSuggestionFn = getComputedSelectSuggestionFn(suggestion, appConstants.KEY_TYPE, appConstants.KEY_SUBTYPE, suggestionTypeSubTypeSelectFnMapping, clearSearchTerms);
                                return (
                                  <li key={index}
                                      className="-mx-4 px-4 py-2 hover:bg-cc-accent-0 font-normal text-cc-primary-contrast hover:text-cc-accent overflow-hidden cursor-pointer group"
                                      tabIndex={index}
                                      onClick={computedSelectSuggestionFn}>
                                    <HighlightedSuggestion suggestion={suggestion[appConstants.KEY_NAME]}
                                                           searchTerms={splitSearchTerms}/>
                                  </li>
                                )
                              }
                            )
                          }
                        </ul>
                      )
                    }
                  )
                }
              </>
            }
            {
              !haveSuggestionsBeenFound && (!recentSearches || !recentSearches.length) &&
              <p className="-mx-4 px-4 pb-2 pt-3">
                {
                  isGetSuggestionsProcessingInProgress ?
                    <ProcessingIndicator size="medium"/>:
                    <>No suggestions found.</>
                }
              </p>
            }

            {
              !!recentSearches && !!recentSearches.length &&
              <ul className="relative">
                <li
                  className="-mx-4 px-4 pt-4 pb-1 uppercase sticky top-0 bg-cc-primary text-cc-muted-contrast">{appConstants.LABEL_PAST_SEARCHES}</li>
                {
                  recentSearches.map(
                    (recentSearch, index) => {
                      const computedSelectRecentSearchFn = getComputedSelectRecentSearchFn(recentSearch, restoreSearch, selectCountryFilterValue, resetSelectedSuggestionFromSearchCriteria, close);
                      return (
                        <li key={index}
                            className="-mx-4 px-4 py-2 hover:bg-cc-accent-0 font-normal text-cc-primary-contrast hover:text-cc-accent overflow-hidden cursor-pointer group flex flex-row flex-wrap items-center space-x-3"
                            tabIndex={index}
                            onClick={computedSelectRecentSearchFn}>
                          <span className="flex flex-row items-center"><IconClock className="flex-shrink-0" aria-hidden="true"/><span className="ml-2 flex-shrink-0">{appConstants.LABEL_PAST_SEARCH} {index+1}</span></span>
                          <span className="flex-shrink flex flex-row flex-wrap items-center">
                            {
                              recentSearch.searchCriteria.map(
                                (searchCriterion, searchCriterionIndex) => {
                                  return (
                                    <small key={searchCriterionIndex} className="bg-cc-muted group-hover:bg-cc-accent-light rounded m-1 px-1.5 py-0.5">{searchCriterion[appConstants.KEY_NAME]}</small>
                                  )
                                }
                              )
                            }
                          </span>
                        </li>
                      )
                    }
                  )
                }
              </ul>
            }

          </div>
        }
      </div>
    </div>
  );

}

